import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faCalendar,
  faCalendarAlt,
  faChartArea,
  faChartPie,
  faClipboardCheck,
  faCogs,
  faDollarSign,
  faDumbbell,
  faFile,
  faHome,
  faList,
  faParking,
  faQuestion,
  faScroll,
  faSlidersH,
  faTag,
  faTaxi,
  faTools,
  faUserCheck,
  faUserClock,
  faUserCog,
  faUserFriends,
  faUserPlus,
  faUserShield,
  faUserTag,
  faWallet,
  faCircleXmark,
  faTable,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faTableColumns,
  faTableList,
  faChevronDown,
  faTableCellsLarge,
  faListUl,
  faListOl,
  faListCheck,
  faHeading,
  faAlignLeft,
  faFloppyDisk,
  faA,
  faFillDrip,
  faImage,
  faArrowDown,
  faTriangleExclamation,
  faCircleCheck,
  faFileSignature,
  faBan,
  faEgg,
  faHourglassEnd,
  faReceipt,
  faCircleMinus,
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'

library.add(
  faChartArea,
  faWallet,
  faCalendarAlt,
  faParking,
  faUserFriends,
  faTaxi,
  faChartPie,
  faUserClock,
  faUserCheck,
  faUserCog,
  faCogs,
  faTools,
  faSlidersH,
  faUserShield,
  faUserTag,
  faAddressBook,
  faUserPlus,
  faScroll,
  faHome,
  faList,
  faClipboardCheck,
  faDumbbell,
  faDollarSign,
  faCalendar,
  faFile,
  faQuestion,
  faTag,
  faCircleXmark,
  faTable,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faTableColumns,
  faTableList,
  faChevronDown,
  faTableCellsLarge,
  faListUl,
  faListOl,
  faListCheck,
  faHeading,
  faAlignLeft,
  faFloppyDisk,
  faA,
  faFillDrip,
  faImage,
  faArrowDown,
  faTriangleExclamation,
  faCircleCheck,
  faFileSignature,
  faBan,
  faEgg,
  faHourglassEnd,
  faReceipt,
  faCircleMinus,
)

Vue.component('FaIcon', FontAwesomeIcon)

export const AppFaIcons = {
  dollar: ['fas', 'dollar-sign'],
  question: ['fas', 'question'],
  table: ['fas', 'table'],
  bold: ['fas', 'bold'],
  italic: ['fas', 'italic'],
  strikethrough: ['fas', 'strikethrough'],
  underline: ['fas', 'underline'],
  tableColumns: ['fas', 'table-columns'],
  tableList: ['fas', 'table-list'],
  chevronDown: ['fas', 'chevron-down'],
  tableCellsLarge: ['fas', 'table-cells-large'],
  listUl: ['fas', 'list-ul'],
  listOl: ['fas', 'list-ol'],
  listCheck: ['fas', 'list-check'],
  heading: ['fas', 'heading'],
  alignLeft: ['fas', 'align-left'],
  list: ['fas', 'list'],
  floppyDisk: ['fas', 'floppy-disk'],
  a: ['fas', 'a'],
  fillDrip: ['fas', 'fill-drip'],
  image: ['fas', 'image'],
  warning: ['fas', 'triangle-exclamation'],
  circleCheck: ['fas', 'circle-check'],
  fileSignature: ['fas', 'file-signature'],
  egg: ['fas', 'egg'],
  hourglassEnd: ['fas', 'hourglass-end'],
  check: ['fas', 'receipt'],
  minus: ['fas', 'circle-minus'],
}
